import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import CalendarIcon from '../../../../../assets/icons/calendar.svg';
import {
  getCourseLabel,
  isCourseIndividual,
} from '../../../../../utils/entity/course';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {course, program} = contexts;
  const courseLabel = getCourseLabel(course);

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    icon: CalendarIcon,
    iconGradient: 'danger',
    title:
      /**
       * @i18n_parser
       *
       * t('notifications:course_is_already_ended.title.individual')
       * t('notifications:course_is_already_ended.title.group')
       */
      i18n.t(
        `notifications:course_is_already_ended.title.${
          isCourseIndividual(course) ? 'individual' : 'group'
        }`,
        {
          courseDates: courseLabel ? `(${courseLabel})` : '',
          courseTitle: program?.title,
        },
      ),
  };
};
